import {Component, EventEmitter, Input, Output} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {RoleControllerService} from "../../../../../services/role-controller/role-controller.service";
import {Store} from "../../../../../services/store.service";
import {BaseError} from "../../../base-error";
import {TranslatedBaseError} from "../../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "role-determinant",
  templateUrl: "./determinant-role.component.html",
  providers: [],
})
export class DeterminantRoleComponent extends TranslatedBaseError {
  public listToggle: boolean = false;
  @Input() public serviceId: string;
  @Input() public role;
  @Output() public editCancel = new EventEmitter();
  @Output() public update = new EventEmitter();

  constructor(private roleController: RoleControllerService,
              private route: ActivatedRoute,
              public store: Store,
              toastr: ToastrService, public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public updateRole() {
    const roleSaveServnice = this.role.type === "BotRole" ? this.roleController.saveBotRole(this.role) : this.roleController.saveUserRole(this.role);
    roleSaveServnice.subscribe(
      (data) => {
        this.responseSuccessful("Saved successfully!");
        this.closeLayer();
        this.update.emit(this.role);
      },
      (error) => {
        this.reloadRole();
        this.showErrorMessage(error);
      },
    );
  }

  public change(event) {
    let jsonDeterminants = event;
    if (typeof event === "object") {
      if (jsonDeterminants.jsonString) {
        jsonDeterminants = jsonDeterminants.jsonString;
      } else {
        jsonDeterminants = JSON.stringify(jsonDeterminants);
      }
    }
    this.role.jsonDeterminants = jsonDeterminants;
  }

  private reloadRole() {
    this.roleController.getRole(this.role.id).subscribe(
      (data) => {
        this.role = data;
      },
      (error) => {
        this.showErrorMessage(error);
      },
    );
  }

  public closeEdit() {
    this.store.state.common.determinantSection.topLayer = "list";
    this.store.state.common.determinantSection.determinant = {};
  }

  public closeLayer() {
    this.editCancel.emit({cancel: true});
  }

  public setListView(b) {
    this.listToggle = b;
  }
}
